"use client"

import { useEffect, useState, useMemo, useCallback } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import iconRenewel2 from "../../../assets/media/icon-renewel-2.svg"
import iconTimeSquare from "../../../assets/media/icon-time-square.svg"
import iconSwap from "../../../assets/media/icon-swap.svg"
import iconTick from "../../../assets/media/icon-tick.svg"
import iconTickOrange from "../../../assets/media/icon-tick-orange.svg"
import iconSearch from "../../../assets/media/icon-search.svg"
import iconStateCompany from "../../../assets/media/icon-state-company.svg"
import iconStateEmployee from "../../../assets/media/icon-state-employee.svg"
import iconStateApplication from "../../../assets/media/icon-state-application.svg"
import iconMenuDots from "../../../assets/media/icon-menu-dots.svg";
import New_Application_Icon from "../../../assets/media/new_application_icon.png";
import Approved_Icon from "../../../assets/media/approved_icon.png";
import Discrepancy_Icon from "../../../assets/media/discrepancy_icon.png";
import Renewal_Icon from "../../../assets/media/renewal_icon.png";

import { Link } from "react-router-dom"
import Navbar from "../../navbar"
import Header from "../../header"
import { useDispatch, useSelector } from "react-redux"
import { fetchApplications, fetchApplicationCounts, fetchAllApplicationsForCounts, resetCountsState } from "../../../store/reducers/applicationSlice"
import { fetchEmployee, fetchAllEmployeesForCounts } from "../../../store/reducers/employeeSlice"
import { fetchForms } from "../../../store/reducers/formSlice"
import { fetchCompanies, fetchAllCompaniesForCounts } from "../../../store/reducers/companiesSlice"
import Pagination from "./appPagination"
import Modal from "../../modal/Modal"
import { getallUserdata } from "../../../store/reducers/userSlice"
//import { AreaChartWithFilters, Filter } from './chartComponents';

import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"
import { getallUser } from "../../../store/reducers/userSlice"

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"

import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table"

export const formatDate = (inputDate) => {
  const date = new Date(inputDate)
  const options = { year: "numeric", month: "long", day: "2-digit" }
  return date.toLocaleDateString(undefined, options)
}

function RadioFilter({ checkboxes, setCheckboxes, setSearchTerm, onStatusChange }) {
  const handleRadioChange = (event) => {
    const { value } = event.target

    console.log('🎯 Radio button clicked:', value);
    console.log('🎯 Calling onStatusChange with:', value);

    // For radio buttons, we need to uncheck all and check only the selected one
    setCheckboxes((prevCheckboxes) => {
      const newCheckboxes = { ...prevCheckboxes }
      // Uncheck all first
      for (const key in newCheckboxes) {
        newCheckboxes[key] = false
      }
      // Check only the selected one
      newCheckboxes[value] = true

      console.log('🎯 Updated radio state:', newCheckboxes);
      return newCheckboxes
    })

    setSearchTerm("")
    onStatusChange(value)
    console.log('🎯 onStatusChange called');
  }

  return (
    <div className="boardFilter">
      {Object.keys(checkboxes).map((radioValue) => (
        <div className="form-check form-check-inline" key={radioValue}>
          <input
            className="form-check-input"
            type="radio"
            name="statusFilter" // All radio buttons share the same name
            value={radioValue}
            checked={checkboxes[radioValue]}
            onChange={handleRadioChange}
            id={radioValue}
          />
          <label htmlFor={radioValue} className="form-check-label">{radioValue}</label>
        </div>
      ))}
    </div>
  )
}

const stateButtonMap = {
  in_process: { className: "status-inprocess", text: "In Process", state: "in_process", },
  pending: { className: "status-pending", text: "Pending", state: "pending" },
  approved: { className: "status-approved", text: "Approved", state: "approved" },
  rejected: { className: "status-rejected", text: "Rejected", state: "rejected" },
  discrepancies: { className: "status-discrepancies", text: "Discrepancies", state: "discrepancies" },
  // pending_for_approval: { className: "status-pending-for-approval", text: "Pending For Approval", state: "pending_for_approval" },
  drafts: { className: "status-drafts", text: "Drafts", state: "drafts" },
  renewal: { className: "status-renewal", text: "Renewal", state: "renewal" },
}

// Mapping between checkbox labels and API state values
const statusFilterMap = {
  "All": null,
  "Approved": "approved",
  "Rejected": "rejected",
  // " Pending For Approval": "pending_for_approval",
  "In Process": "in_process",
  "Discrepancies": "discrepancies",
  "Renewal": "renewal"
}

const AppDashboard = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)
  const [data, setData] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [searchBy, setSearchBy] = useState("applicationId") // Default search by Application ID
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("")
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const getallUserdata = useSelector((state) => state.usersdata.getalluserdata)
  const employee = useSelector((state) => state.employee.users)
  const allEmployees = useSelector((state) => state.employee.allEmployees)
  const forms = useSelector((state) => state.forms.data)
  const company = useSelector((state) => state.companies.companies)
  const allCompanies = useSelector((state) => state.companies.allCompanies)
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString())
  const [selectedCompany, setselectedCompany] = useState("All")
  const [showModal, setShowModal] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [checkboxes, setCheckboxes] = useState({
    All: true,
    Approved: false,
    Rejected: false,
    // " Pending For Approval": false,
    "In Process": false,
  })

  // State for server-side filtering
  const [selectedStatus, setSelectedStatus] = useState("All")

  const applicationRecords = useSelector((state) => state.applications.data)
  const allApplications = useSelector((state) => state.applications.allApplications) // All applications for filtering
  const applicationLoading = useSelector((state) => state.applications.fetchLoading)
  const applicationError = useSelector((state) => state.applications.fetchError)
  const pagination = useSelector((state) => state.applications.pagination)
  const applicationCounts = useSelector((state) => state.applications.counts)
  const countsLoading = useSelector((state) => state.applications.countsLoading)
  const countsError = useSelector((state) => state.applications.countsError)
  const fallbackAttempted = useSelector((state) => state.applications.fallbackAttempted)
  const accessToken = useSelector((state) => state.auth.user?.access_token)

  // Debug logging
  console.log('📊 Dashboard Debug Info:', {
    applicationRecords,
    applicationLoading,
    applicationError,
    applicationCounts,
    countsLoading,
    countsError,
    fallbackAttempted,
    accessToken: accessToken ? `Present (${accessToken.substring(0, 20)}...)` : 'Missing',
    user: user,
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'Not Set',
    applicationRecordsType: typeof applicationRecords,
    applicationRecordsIsArray: Array.isArray(applicationRecords),
    applicationRecordsLength: applicationRecords?.length,
    currentPage,
    itemsPerPage,
    searchTerm,
    selectedStatus,
    checkboxes,
    usingServerSideFiltering: true
  })

  const dataUsers = useMemo(() => {
    const data = [
      { name: "Jan", Users: 0 },
      { name: "Feb", Users: 0 },
      { name: "Mar", Users: 0 },
      { name: "Apr", Users: 0 },
      { name: "May", Users: 0 },
      { name: "Jun", Users: 0 },
      { name: "Jul", Users: 0 },
      { name: "Aug", Users: 0 },
      { name: "Sep", Users: 0 },
      { name: "Oct", Users: 0 },
      { name: "Nov", Users: 0 },
      { name: "Dec", Users: 0 },
    ]

    if (Array.isArray(getallUserdata)) {
      getallUserdata.forEach((user) => {
        const year = new Date(user.created_at).getFullYear()
        if (selectedYear === "All" || year.toString() === selectedYear) {
          const month = new Date(user.created_at).getMonth()
          data[month].Users++
        }
      })
    }

    return data
  }, [getallUserdata, selectedYear])

  const dataApplications = useMemo(() => {
    const data = [
      { name: "Jan", Applications: 0 },
      { name: "Feb", Applications: 0 },
      { name: "Mar", Applications: 0 },
      { name: "Apr", Applications: 0 },
      { name: "May", Applications: 0 },
      { name: "Jun", Applications: 0 },
      { name: "Jul", Applications: 0 },
      { name: "Aug", Applications: 0 },
      { name: "Sep", Applications: 0 },
      { name: "Oct", Applications: 0 },
      { name: "Nov", Applications: 0 },
      { name: "Dec", Applications: 0 },
    ]

    // Use allApplications for accurate chart (contains all records, not just current page)
    const applicationsArray = Array.isArray(allApplications)
      ? allApplications
      : []

    if (Array.isArray(applicationsArray)) {
      applicationsArray.forEach((application) => {
        const year = new Date(application.created_at).getFullYear()
        if (selectedYear === "All" || year.toString() === selectedYear) {
          const month = new Date(application.created_at).getMonth()
          data[month].Applications++
        }
      })
    }

    return data
  }, [allApplications, selectedYear])

  const dataEmployees = useMemo(() => {
    const data = [
      { name: "Jan", Employees: 0 },
      { name: "Feb", Employees: 0 },
      { name: "Mar", Employees: 0 },
      { name: "Apr", Employees: 0 },
      { name: "May", Employees: 0 },
      { name: "Jun", Employees: 0 },
      { name: "Jul", Employees: 0 },
      { name: "Aug", Employees: 0 },
      { name: "Sep", Employees: 0 },
      { name: "Oct", Employees: 0 },
      { name: "Nov", Employees: 0 },
      { name: "Dec", Employees: 0 },
    ]

    // Use allEmployees for accurate chart (contains all records, not just current page)
    const sourceData = allEmployees && allEmployees.length > 0
      ? allEmployees
      : employee;

    if (Array.isArray(sourceData)) {
      sourceData.forEach((Employee) => {
        const year = new Date(Employee.created_at).getFullYear()
        if (selectedYear === "All" || year.toString() === selectedYear) {
          const month = new Date(Employee.created_at).getMonth()
          data[month].Employees++
        }
      })
    }

    return data
  }, [employee, allEmployees, selectedYear])

  const authToken = user.access_token

  // Server-side filtering - just format the data
  const processedData = useCallback(() => {
    // Handle both array and object responses from API
    const applicationsArray = Array.isArray(applicationRecords)
      ? applicationRecords
      : applicationRecords?.applications || applicationRecords?.data || [];

    if (!Array.isArray(applicationsArray)) {
      setData([])
      return []
    }

    // Format the data (server handles filtering)
    // Client-side filtering removed as server now filters these out
    const processedData = applicationsArray
      .map((item) => ({
        ...item,
        created_at: formatDate(item.created_at),
        updated_at: formatDate(item.updated_at),
        stateText: stateButtonMap[item.state]?.text || item.state,
      }))

    console.log(`✅ Server-side filtered data:`, {
      total: processedData.length,
      filter: selectedStatus !== "All" ? `${selectedStatus} (${statusFilterMap[selectedStatus]})` : "All",
      search: searchTerm || "None",
      records: processedData.map(item => ({ id: item.id, state: item.state, stateText: item.stateText }))
    });

    setData(processedData)
    return processedData
  }, [applicationRecords, selectedStatus, searchTerm])

  const filter_company_employee = useMemo(() => {
    // Use allEmployees for accurate counts (contains all employees, not just current page)
    // Fall back to employee if allEmployees is not yet loaded
    const sourceData = allEmployees && allEmployees.length > 0
      ? allEmployees
      : employee;

    return sourceData.filter((Employee) => {
      // Exclude company_admin from the count
      if (Employee.user_role === "company_admin" || Employee.user_role === "reviewer" || Employee.user_role === "viewer" || Employee.user_role === "editor" || Employee.user_role === "admin") {
        return false
      }

      if (selectedCompany === "All") {
        return true
      } else {
        return Employee.company_id === Number(selectedCompany)
      }
    })
  }, [employee, allEmployees, selectedCompany])

  const filter_company_application = useMemo(() => {
    // Use allApplications for accurate company filtering (includes all records, not just current page)
    // Fall back to applicationRecords if allApplications is not yet loaded
    const sourceData = allApplications && allApplications.length > 0
      ? allApplications
      : applicationRecords;

    console.log("🔍 filter_company_application DEBUG:", {
      allApplicationsLength: allApplications?.length,
      applicationRecordsLength: applicationRecords?.length,
      using: allApplications && allApplications.length > 0 ? "allApplications" : "applicationRecords",
      selectedCompany
    });

    // Handle both array and object responses from API
    const applicationsArray = Array.isArray(sourceData)
      ? sourceData
      : sourceData?.applications || sourceData?.data || [];

    if (!Array.isArray(applicationsArray)) {
      return []
    }

    return applicationsArray.filter((application) => {
      if (selectedCompany === "All") {
        // Show all applications regardless of user/company association (count everything)
        return true;
      } else {
        const companyIdNumber = Number(selectedCompany)

        // Check direct company_id field first (most reliable)
        if (application.company_id === companyIdNumber || application.companyId === companyIdNumber ||
          application.company?.id === companyIdNumber) {
          return true
        }

        // Fallback: Check via employee relationship using allEmployees if available
        return filter_company_employee.some((employee) => {
          return application.user_id === Number(employee.id)
        })
      }
    })
  }, [allApplications, applicationRecords, filter_company_employee, selectedCompany])

  const filter_company = useMemo(() => {
    // Use allCompanies for accurate counts (contains all companies, not just current page)
    // Fall back to company if allCompanies is not yet loaded
    const sourceData = allCompanies && allCompanies.length > 0
      ? allCompanies
      : company;

    return sourceData.filter((item) => {
      if (selectedCompany === "All") {
        return item
      } else {
        return item.id === Number(selectedCompany)
      }
    })
  }, [company, allCompanies, selectedCompany])

  useEffect(() => {
    if (authToken) {
      dispatch(getallUser({ authToken: authToken }))
      dispatch(fetchEmployee({ accessToken: authToken }))
      dispatch(fetchAllEmployeesForCounts({ accessToken: authToken }))
      dispatch(fetchForms({ accessToken: authToken }))
      dispatch(fetchCompanies({ accessToken: authToken }))
      dispatch(fetchAllCompaniesForCounts({ accessToken: authToken }))

      // Since counts API doesn't exist yet, go straight to fallback
      console.log('Counts API not available, using fallback method directly');
      dispatch(fetchAllApplicationsForCounts({ accessToken: authToken }));
    }

    // Cleanup on unmount
    return () => {
      dispatch(resetCountsState());
    };
  }, [authToken, dispatch])

  // Note: Fallback mechanism removed since we go directly to fallback on mount

  // Debounce search term to avoid too many API calls
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim())
    }, 500) // 500ms debounce delay

    return () => clearTimeout(timer)
  }, [searchTerm])

  // Fetch applications (client-side filtering handles the rest)
  useEffect(() => {
    const loadApplications = async () => {
      if (accessToken && accessToken.trim() !== '') {
        try {
          console.log('📡 Fetching applications from server...')

          // Server-side filtering - backend supports state parameter
          const queryParams = {
            page: currentPage,
            limit: itemsPerPage || 10
          }

          // Only add search parameter if there's a search term
          if (debouncedSearchTerm && debouncedSearchTerm.trim() !== '') {
            // Dynamic key based on searchBy selection
            queryParams[searchBy] = debouncedSearchTerm.trim()
          }

          if (startDate) {
            queryParams.createdFrom = moment(startDate).format("YYYY-MM-DD")
          }
          if (endDate) {
            queryParams.createdTo = moment(endDate).format("YYYY-MM-DD")
          }

          // Add state filter 
          if (selectedStatus !== "All") {
            const statusValue = statusFilterMap[selectedStatus]
            if (statusValue) {
              queryParams.state = statusValue
            }
          } else {
            // If "All" is selected, we explicitly request all VALID states
            // This excludes "application_submitted_by_company_user_to_company" server-side
            // ensuring we get a full page of 10 valid items.
            queryParams.state = [
              "in_process",
              "pending",
              "approved",
              "rejected",
              "discrepancies",
              // "pending_for_approval",
              "drafts",
              "renewal"
            ];
          }



          // Use the regular fetchApplications Redux action
          await dispatch(fetchApplications({
            accessToken,
            queryParams
          }))
        } catch (error) {
          console.error('Error fetching applications:', error)
        }
      } else {
        console.log('No valid access token available for fetchApplications')
      }
    }

    loadApplications()
  }, [accessToken, dispatch, currentPage, itemsPerPage, debouncedSearchTerm, selectedStatus, searchBy, startDate, endDate]) // Server-side filtering

  // Handle status filter changes
  const handleStatusChange = useCallback((status) => {
    setSelectedStatus(status);
    setCurrentPage(1); // Reset to first page when filter changes
  }, [selectedStatus]);

  // Retry mechanism for failed application fetch
  useEffect(() => {
    if (applicationError && accessToken) {
      console.log('Application fetch failed, retrying in 3 seconds...');
      const retryTimeout = setTimeout(() => {
        const queryParams = {
          page: currentPage,
          limit: itemsPerPage || 10
        }

        // Only add search parameter if there's a search term
        if (debouncedSearchTerm && debouncedSearchTerm.trim() !== '') {
          // Dynamic key based on searchBy selection
          queryParams[searchBy] = debouncedSearchTerm.trim()
        }

        if (startDate) {
          queryParams.createdFrom = moment(startDate).format("YYYY-MM-DD")
        }
        if (endDate) {
          queryParams.createdTo = moment(endDate).format("YYYY-MM-DD")
        }

        // Add state filter 
        if (selectedStatus !== "All") {
          const statusValue = statusFilterMap[selectedStatus]
          if (statusValue) {
            queryParams.state = statusValue
          }
        } else {
          // If "All" is selected, we explicitly request all VALID states
          queryParams.state = [
            "in_process",
            "pending",
            "approved",
            "rejected",
            "discrepancies",
            // "pending_for_approval",
            "drafts",
            "renewal"
          ];
        }

        dispatch(fetchApplications({
          accessToken: accessToken,
          queryParams
        }));
      }, 3000);

      return () => clearTimeout(retryTimeout);
    }
  }, [applicationError, accessToken, dispatch, currentPage, itemsPerPage, debouncedSearchTerm, selectedStatus, searchBy])

  const handleInputChange = useCallback(
    (event) => {
      let value = event.target.value

      if (searchBy === "applicationId") {
        // Strip 'GB-' prefix if present and remove non-numeric characters
        value = value.replace(/^gb-?/i, "").replace(/\D/g, "")
      }

      setSearchTerm(value)
      // Reset to page 1 when searching
      setCurrentPage(1)
      // No need to call filtered() since server-side filtering handles this
    },
    [searchBy],
  )

  const handleItemsPerPageChange = useCallback((newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to page 1 when changing items per page
  }, []);

  const handleSearchByChange = (e) => {
    setSearchBy(e.target.value);
    setSearchTerm("");
  };

  useEffect(() => {
    processedData()
  }, [processedData])

  const getTotalPages = useCallback(() => {
    // Use server-side pagination metadata
    if (pagination?.totalPages) {
      return pagination.totalPages;
    }
    // Fallback to client-side calculation
    const applicationsArray = Array.isArray(applicationRecords)
      ? applicationRecords
      : applicationRecords?.applications || applicationRecords?.data || [];
    const validItemsPerPage = itemsPerPage || 10;
    return Math.ceil(applicationsArray.length / validItemsPerPage);
  }, [pagination?.totalPages, applicationRecords, itemsPerPage])

  const getApplicationCount = useCallback(() => {
    // Use Redux state counts (either from server-side counts API or calculated from all applications)
    if (applicationCounts && !countsLoading) {
      return applicationCounts;
    }

    // Fallback to client-side calculation from allApplications (not just current page)
    // This ensures accurate counts even when counts API is not available
    let newApplications = 0,
      pendingFromDW = 0,
      discrepencies = 0,
      approved = 0,
      renewal = 0

    // Use allApplications for accurate counts (contains all applications, not just current page)
    // Fall back to applicationRecords only if allApplications is not available
    const sourceData = allApplications && allApplications.length > 0
      ? allApplications
      : applicationRecords;

    // Handle both array and object responses from API
    const applicationsArray = Array.isArray(sourceData)
      ? sourceData
      : sourceData?.applications || sourceData?.data || [];

    if (Array.isArray(applicationsArray)) {
      applicationsArray.forEach((item) => {
        // Check if application is in "renewal" state OR is "approved" and due within 15 days
        const isDueSoon = item.state === "approved" &&
          item.due_date &&
          moment(item.due_date).isBefore(moment().add(15, 'days')) &&
          moment(item.due_date).isAfter(moment().subtract(1, 'days'));

        if (item.state === "in_process") newApplications++
        else if (item.state === "pending_for_approval") pendingFromDW++
        else if (item.state === "discrepancies") discrepencies++
        else if (item.state === "approved") approved++

        if (item.state === "renewal" || isDueSoon) renewal++
      })
    }

    return { newApplications, pendingFromDW, discrepencies, approved, renewal };
  }, [applicationCounts, countsLoading, allApplications, applicationRecords])

  const { handleChange, handleBlur, handleSubmit, values, touched, errors } = useFormik({
    initialValues: {
      category: "",
      "application-name": "",
      "application-type": "",
    },
    validationSchema: Yup.object({
      category: Yup.string().required("Category is required"),
      "application-name": Yup.string().required("Application Name is required"),
      "application-type": Yup.string().required("Application Type is required"),
    }),
    onSubmit: (formValues) => {
      console.log({ formValues: formValues })
      // dispatch(loginUser({ emailOrPhone: formValues.email, password: formValues.password }));
    },
  })

  const show = () => setShowModal(true)
  const close = () => setShowModal(false)

  // Since we're using server-side pagination, we don't need client-side pagination
  const paginatedData = useMemo(() => {
    console.log("Dashboard - paginatedData calculation:", { data });
    const result = (data ?? [])
      .sort((a, b) => b.applicationId - a.applicationId);
    console.log("Dashboard - paginatedData result:", result);
    return result;
  }, [data])

  const columns = useMemo(
    () => [
      {
        id: "serial_number",
        header: "S.NO.",
        cell: (info) => {
          if (!info?.row) return <span>—</span>;
          return (currentPage - 1) * itemsPerPage + info.row.index + 1;
        },
      },
      {
        id: "id",
        header: "Application No.",
        accessorKey: "id",
        cell: (info) => {
          const row = info?.row?.original;
          return `GB-${row.id}`;
        },
      },
      {
        id: "application_name",
        header: "Application Name",
        cell: (info) => {
          const row = info?.row?.original;
          return (
            <div className="boardTitle">
              <strong>{row.name?.length > 50
                ? `${row.name.substring(0, 50)}...`
                : row.name}
              </strong>
              <span>{row?.categoryName || 'N/A'}</span>
            </div>
          );
        },
      },
      {
        id: "submittedBy",
        header: "Submitted By",
        cell: (info) => {
          const row = info?.row?.original;
          return (
            <div className="boardTitle">
              <strong>{row.companyName || row.company_name || 'N/A'}</strong>
              <span>{row.companyEmail || row.company_email || 'N/A'}</span>
            </div>
          );
        }
      },
      {
        id: "submittedFor",
        header: "Submitted For",
        cell: (info) => {
          const row = info?.row?.original;
          if (!row) return <span>—</span>;

          return (
            <div className="boardTitle">
              <strong>{row.userName || row.user_name || 'N/A'}</strong>
              <span>{row.userEmail || row.user_email || row.email || 'N/A'}</span>
            </div>
          );
        },
      },
      {
        id: "submittedDate",
        header: "Submitted Date",
        accessorKey: "updated_at",
        cell: ({ getValue }) => {
          const value = getValue();
          return value ? formatDate(value) : <span>—</span>;
        },
      },
      {
        id: "registeredDate",
        header: "Last Updated",
        accessorKey: "created_at",
        cell: ({ getValue }) => {
          const value = getValue();
          return value ? formatDate(value) : <span>—</span>;
        },
      },
      {
        id: "status",
        header: "Status",
        cell: (info) => {
          const row = info?.row?.original;
          if (!row) return <span>—</span>;

          const stateInfo = stateButtonMap[row.state];
          return (
            <Link className={`reasonText boardButton   ${stateInfo?.className || ""}`} >
              {stateInfo?.text || "Unknown"}
            </Link>
          );
        },
      },
      // {
      //   id: "attachments",
      //   header: "Attachments",
      //   cell: () => (
      //     <div className="boardDownload d-flex gap-2" >
      //       <Link to={"/"}>
      //         <img src={iconFilePdf || "/placeholder.svg"} alt="" />
      //       </Link>
      //       <Link to={"/"}>
      //         <img src={iconFileDoc || "/placeholder.svg"} alt="" />
      //       </Link>
      //       <Link to={"/"}>
      //         <img src={iconFileImage || "/placeholder.svg"} alt="" />
      //       </Link>
      //     </div>
      //   ),
      // },
      {
        id: "actions",
        header: "Actions",
        cell: (info) => {
          const row = info?.row?.original;
          if (!row) return <span>—</span>;

          return (
            <div className="boardActions">
              <div className="dropdown d-inline-flex">
                <button
                  className="application-dropdown dropdown-toggle border-0 bg-transparent"
                  type="button"
                  id={`dropdownMenuButton-${row.applicationId || row.id}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={iconMenuDots} alt="Menu Dots" />
                </button>

                <ul
                  className="dropdown-menu"
                  aria-labelledby={`dropdownMenuButton-${row.applicationId || row.id}`}
                >
                  <li>
                    <Link
                      id={`dropdownMenuButton-${row.id}`}
                      to={`/view-applications/${row.id}`}
                      className="dropdown-item"
                    >
                      View
                    </Link>
                  </li>
                  <li>
                    <button
                      // onClick={() => handleChangeStatus(row, 4)}
                      className="dropdown-item"
                    >
                      Download
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      },

    ],
    [getallUserdata, currentPage, itemsPerPage],
  )

  const table = useReactTable({
    data: Array.isArray(paginatedData) ? paginatedData : [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  // Show loading state - only show full page loader on initial load
  const isInitialLoad = applicationLoading && (!applicationRecords || applicationRecords.length === 0);

  if (isInitialLoad) {
    return (
      <>
        <Navbar />
        <Header />
        <div className="wrapper">
          <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading applications...</p>
            </div>
          </div>
        </div>
      </>
    )
  }

  if (!table) {
    return <p>loading</p>
  }

  return (
    <>
      <div>
        <Navbar />
        <Header />
        <div className="wrapper">
          <div className="">
            <div className="">
              <div className="profHeader mb-4">
                <div className="profHeadLeft">
                  <h2>Application Forms</h2>
                </div>
                <div className="profHeadRight">
                  {/* <button className="buttonPrimary" onClick={show}>
                    Create Form
                  </button> */}
                </div>
              </div>
              <div className="d-flex gap-4 mb-4">
                {/* {countsLoading && (
                  <div className="alert alert-info mb-3 w-100" role="alert">
                    <small>
                      <i className="fas fa-info-circle me-1"></i>
                      Loading application counts...
                    </small>
                  </div>
                )} */}
                {/* {selectedStatus !== "All" && (
                  <div className="alert alert-success mb-3 w-100" role="alert">
                    <small>
                      <i className="fas fa-filter me-1"></i>
                      <strong>Server Filter Active:</strong> Showing only "{selectedStatus}" applications
                      {searchTerm && <span> • <i className="fas fa-search me-1"></i>Search: "{searchTerm}"</span>}
                    </small>
                  </div>
                )} */}
                {/* {searchTerm && selectedStatus === "All" && (
                  <div className="alert alert-success mb-3 w-100" role="alert">
                    <small>
                      <i className="fas fa-search me-1"></i>
                      <strong>Server Search Active:</strong> Searching for "{searchTerm}" across all applications
                    </small>
                  </div>
                )} */}
                <div className="appState  w-100 d-flex justify-content-between">
                  <div className="d-flex flex-column">
                    <h4>New Application</h4>
                    <h3>
                      <span>
                        {countsLoading ? (
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          getApplicationCount().newApplications
                        )}
                      </span>
                    </h3>
                  </div>


                  <div className="d-flex flex-column justify-content-between">
                    <img width={"50px"} height={"50px"} src={New_Application_Icon || "/placeholder.svg"} alt="" />
                    <Link to={"/in-process-applications"}>View All</Link>
                  </div>
                </div>
                <div className="appState w-100 d-flex justify-content-between">
                  <div className="d-flex flex-column">
                    <h4>Discrepancies</h4>
                    <h3>
                      <span>
                        {countsLoading ? (
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          getApplicationCount().discrepencies
                        )}
                      </span>
                    </h3>

                  </div>
                  <div className="d-flex flex-column justify-content-between">
                    <img width={"50px"} height={"50px"} src={Discrepancy_Icon || "/placeholder.svg"} alt="" />
                    <Link to={"/discrepancies"}>View All</Link>
                  </div>
                </div>
                <div className="appState  w-100 d-flex justify-content-between">
                  <div className="d-flex flex-column">
                    <h4>Approved</h4>
                    <h3>
                      <span>
                        {countsLoading ? (
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          getApplicationCount().approved
                        )}
                      </span>
                    </h3>
                  </div>
                  <div className="d-flex flex-column justify-content-between">
                    <img width={"50px"} height={"50px"} src={Approved_Icon || "/placeholder.svg"} alt="" />
                    <Link to={"/approved-applications"}>View All</Link>
                  </div>
                </div>
                <div className="appState  w-100 d-flex justify-content-between">
                  <div className="d-flex flex-column">
                    <h4>Renewal</h4>
                    <h3>
                      <span>
                        {countsLoading ? (
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          getApplicationCount().renewal
                        )}
                      </span>
                    </h3>
                  </div>
                  <div className="d-flex flex-column justify-content-between">
                    <img width={"50px"} height={"50px"} src={Renewal_Icon || "/placeholder.svg"} alt="" />
                    <Link to={"/renewals"}>View All</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="boxWhite boxChart">
                <div className="rowChartHead">
                  <div className="colChartHead">
                    <h3>
                      <b>{allApplications.length}</b>
                      <span>Submitted Forms</span>
                    </h3>
                  </div>
                  <div className="colChartHead">
                    <ul className="nav nav-tabs" id="myTab">
                      <li className="nav-item">
                        <button
                          className="nav-link active"
                          data-bs-toggle="tab"
                          data-bs-target="#dataApplications"
                          type="button"
                        >
                          Applications
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#dataUsers"
                          type="button"
                        >
                          User Registration
                        </button>
                      </li>
                      <li className="nav-item">
                        <button className="nav-link" data-bs-toggle="tab" data-bs-target="#dataEmployees" type="button">
                          No. of Employees
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="colChartHead">
                    <select
                      className="form-select"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                    >
                      <option value="All">
                        Select Year
                      </option>
                      {[...Array(10)].map((_, index) => {
                        const year = new Date().getFullYear() - index
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                </div>
                <div className="tab-content">
                  <div className="tab-pane active" id="dataApplications">
                    <div className="dataApplications">
                      <ResponsiveContainer width="100%" height={225}>
                        <AreaChart
                          data={dataApplications}
                          margin={{
                            top: 10,
                            right: 20,
                            left: 0,
                            bottom: 10,
                          }}
                        >
                          <defs>
                            <linearGradient id="colorApplications" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor="#114DF2" stopOpacity={0.8} />
                              <stop offset="95%" stopColor="#114DF2" stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke="#E5E5E5" />
                          <XAxis
                            dataKey="name"
                            tick={{ fill: '#082A51', fontSize: 12 }}
                            axisLine={{ stroke: '#D9D9D9' }}
                          />
                          <YAxis
                            allowDecimals={false}
                            tick={{ fill: '#082A51', fontSize: 12 }}
                            axisLine={{ stroke: '#D9D9D9' }}
                          />
                          <Tooltip
                            contentStyle={{
                              backgroundColor: '#fff',
                              border: '1px solid #D9D9D9',
                              borderRadius: '4px',
                              padding: '8px'
                            }}
                          />
                          <Area
                            type="monotone"
                            dataKey="Applications"
                            stroke="#114DF2"
                            fillOpacity={1}
                            fill="url(#colorApplications)"
                            strokeWidth={2}
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                  <div className="tab-pane" id="dataUsers">
                    <div className="dataUsers">
                      <ResponsiveContainer width="100%" height={225}>
                        <AreaChart
                          data={dataUsers}
                          margin={{
                            top: 10,
                            right: 20,
                            left: 0,
                            bottom: 10,
                          }}
                        >
                          <defs>
                            <linearGradient id="colorUsers" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor="#114DF2" stopOpacity={0.8} />
                              <stop offset="95%" stopColor="#114DF2" stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke="#E5E5E5" />
                          <XAxis
                            dataKey="name"
                            tick={{ fill: '#082A51', fontSize: 12 }}
                            axisLine={{ stroke: '#D9D9D9' }}
                          />
                          <YAxis
                            allowDecimals={false}
                            tick={{ fill: '#082A51', fontSize: 12 }}
                            axisLine={{ stroke: '#D9D9D9' }}
                          />
                          <Tooltip
                            contentStyle={{
                              backgroundColor: '#fff',
                              border: '1px solid #D9D9D9',
                              borderRadius: '4px',
                              padding: '8px'
                            }}
                          />
                          <Area
                            type="monotone"
                            dataKey="Users"
                            stroke="#114DF2"
                            fillOpacity={1}
                            fill="url(#colorUsers)"
                            strokeWidth={2}
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                  <div className="tab-pane" id="dataEmployees">
                    <div className="dataEmployees">
                      <ResponsiveContainer width="100%" height={225}>
                        <AreaChart
                          data={dataEmployees}
                          margin={{
                            top: 10,
                            right: 20,
                            left: 0,
                            bottom: 10,
                          }}
                        >
                          <defs>
                            <linearGradient id="colorEmployees" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor="#114DF2" stopOpacity={0.8} />
                              <stop offset="95%" stopColor="#114DF2" stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke="#E5E5E5" />
                          <XAxis
                            dataKey="name"
                            tick={{ fill: '#082A51', fontSize: 12 }}
                            axisLine={{ stroke: '#D9D9D9' }}
                          />
                          <YAxis
                            allowDecimals={false}
                            tick={{ fill: '#082A51', fontSize: 12 }}
                            axisLine={{ stroke: '#D9D9D9' }}
                          />
                          <Tooltip
                            contentStyle={{
                              backgroundColor: '#fff',
                              border: '1px solid #D9D9D9',
                              borderRadius: '4px',
                              padding: '8px'
                            }}
                          />
                          <Area
                            type="monotone"
                            dataKey="Employees"
                            stroke="#114DF2"
                            fillOpacity={1}
                            fill="url(#colorEmployees)"
                            strokeWidth={2}
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="formStates boxWhite">
                <div className="d-flex justify-content-between align-items-center mb-3 gap-5">
                  {/* <h4>Company</h4> */}
                  <select
                    className="form-select"
                    value={selectedCompany}
                    onChange={(e) => setselectedCompany(e.target.value)}
                  >
                    <option value="All">
                      All Companies
                    </option>
                    {company
                      ? company.map((item, index) => {
                        return (
                          <option value={item.id} key={index}>
                            {item.company_name}
                          </option>
                        )
                      })
                      : ""}
                  </select>
                </div>

                <div className="rowCompanyStates">
                  <div className="colCompanyStates">
                    <div className="infoCompanyStates">
                      <img src={iconStateCompany || "/placeholder.svg"} alt="" />
                      <span>All Operators</span>
                    </div>
                    <div className="numCompanyStates">
                      <span>{filter_company.length}</span>
                    </div>
                  </div>
                  <div className="colCompanyStates">
                    <div className="infoCompanyStates">
                      <img src={iconStateEmployee || "/placeholder.svg"} alt="" />
                      <span>Employees</span>
                    </div>
                    <div className="numCompanyStates">
                      <span>{filter_company_employee.length}</span>
                    </div>
                  </div>
                  <div className="colCompanyStates">
                    <div className="infoCompanyStates">
                      <img src={iconStateApplication || "/placeholder.svg"} alt="" />
                      <span>Applications</span>
                    </div>
                    <div className="numCompanyStates">
                      <span>{filter_company_application.length}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="boxAppBoard boxWhite">
            <div className="boardHeader">
              <RadioFilter setSearchTerm={setSearchTerm} checkboxes={checkboxes} setCheckboxes={setCheckboxes} onStatusChange={handleStatusChange} />
              <div className="boardHeadRight">
                <div className="">
                  <select onChange={handleSearchByChange} value={searchBy}>
                    <option value="applicationId">Search by Application ID</option>
                    <option value="companyName">Search by Company Name</option>
                    <option value="username">Search by Employee Name</option>
                  </select>
                </div>
                <div className="searchForm">
                  <input
                    type="text"
                    placeholder={searchBy === "applicationId" ? "GB-XXX" : "Search"}
                    onChange={handleInputChange}
                    value={searchBy === "applicationId" && searchTerm ? `GB-${searchTerm}` : searchTerm}
                  />
                  <button>
                    <img src={iconSearch || "/placeholder.svg"} alt="" />
                  </button>
                </div>
                <div className="datePicker">
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      const [start, end] = update;
                      setStartDate(start);
                      setEndDate(end);
                      setCurrentPage(1);
                    }}
                    isClearable={true}
                    placeholderText="Select Date Range"
                    dateFormat="dd/MM/yyyy"
                    className="date-range-input"
                  />
                </div>
              </div>
            </div>
            <div className="boardContent" style={{ position: 'relative' }}>
              {/* Loader overlay for table section */}
              {applicationLoading && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                    borderRadius: '4px'
                  }}
                >
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 mb-0">Loading applications...</p>
                  </div>
                </div>
              )}
              {/* Table Head */}
              <div className="boardThead table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {table.getHeaderGroups()?.map((headerGroup) =>
                        headerGroup.headers.map((header, i) => (
                          <th key={i}>
                            {flexRender(header.column.columnDef.header, header.getContext())}
                          </th>
                        ))
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {applicationLoading ? (
                      <tr>
                        <td colSpan={table.getHeaderGroups()?.[0]?.headers.length} style={{ textAlign: "center", padding: "20px" }}>
                          <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : applicationError ? (
                      <tr>
                        <td colSpan={table.getHeaderGroups()?.[0]?.headers.length} style={{ textAlign: "center", padding: "20px" }}>
                          <span className="text-danger">
                            Error: No applications found
                          </span>
                        </td>
                      </tr>
                    ) : table.getRowModel()?.rows?.length > 0 ? (
                      table.getRowModel().rows.map((row) => (
                        <tr className={row.id} key={row.id}>
                          {row.getVisibleCells().map((cell, i) => (
                            <td key={i} className="">
                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={table.getHeaderGroups()?.[0]?.headers.length} style={{ textAlign: "center", padding: "20px" }}>
                          {!paginatedData || paginatedData.length === 0 ? "No applications found" : "No data available"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

              </div>



            </div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={getTotalPages}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
              totalItems={pagination?.totalItems || applicationRecords?.length || 0}
            />
          </div>
        </div>
      </div >
      <Modal show={showModal} colWidth={3}>
        <div className="">
          <p>Create Application Form</p>
          <form onSubmit={handleSubmit}>
            <div className="mb-3 d-flex flex-column">
              <label
                style={{
                  color: "var(--day-break-blue-10, #082A51)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "22px",
                }}
              >
                Category
              </label>
              <input
                className="form-class"
                style={{
                  padding: 5,
                  borderRadius: "6px",
                  border: "1px solid var(--neutral-5, #D9D9D9)",
                  background: "var(--neutral-1, #FFF)",
                }}
                value={values["category"]}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete={"false"}
                id={"category"}
                name={"category"}
              />
              {touched["category"] && errors["category"] && <div className="error-message">{errors["category"]}</div>}
            </div>
            <div className="mb-3 d-flex flex-column">
              <label
                style={{
                  color: "var(--day-break-blue-10, #082A51)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "22px",
                }}
              >
                Application Name
              </label>
              <input
                className="form-class"
                style={{
                  padding: 5,
                  borderRadius: "6px",
                  border: "1px solid var(--neutral-5, #D9D9D9)",
                  background: "var(--neutral-1, #FFF)",
                }}
                value={values["application-name"]}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete={"false"}
                id={"application-name"}
                name={"application-name"}
              />
              {touched["application-name"] && errors["application-name"] && (
                <div className="error-message">{errors["application-name"]}</div>
              )}
            </div>
            <div className="mb-3 d-flex flex-column">
              <label
                style={{
                  color: "var(--day-break-blue-10, #082A51)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "22px",
                }}
              >
                Application Type
              </label>
              <input
                className="form-class"
                style={{
                  padding: 5,
                  borderRadius: "6px",
                  border: "1px solid var(--neutral-5, #D9D9D9)",
                  background: "var(--neutral-1, #FFF)",
                }}
                value={values["application-type"]}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete={"false"}
                id={"application-type"}
                name={"application-type"}
              />
              {touched["application-type"] && errors["application-type"] && (
                <div className="error-message">{errors["application-type"]}</div>
              )}
            </div>
            <div className="d-flex justify-content-between">
              <div className="">
                <button type="submit" className="create-form-button">
                  Create
                </button>
              </div>
              <div className="gb-form-footer">
                <button type="button" onClick={close} className="create-form-cancel-button">
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}
export default AppDashboard
